import { getAccess } from '../../auth/access';
import { protectedLoader } from '../../auth/guards';
import ModuleDashboardPage from './pages/ModuleDashboardPage';

const LABELS: Record<string, string> = {
  my: 'My Workspace',
  projects: 'Projects',
  tasks: 'Tasks',
  hr: 'HR',
  recruitment: 'Recruitment',
  payroll: 'Payroll',
  billing: 'Billing',
  accounts: 'Accounts',
  website: 'Website',
  admin: 'Admin',
};

/**
 * Module dashboards. Any signed-in user may open the route; the page itself shows "no access"
 * when the server answers 403 for a module the user has no screen of.
 */
export const dashboardRoutes = [
  {
    path: '/dashboards/:module',
    element: <ModuleDashboardPage />,
    handle: {
      breadcrumb: (p: Record<string, string | undefined>) => {
        const code = p.module ?? '';
        const label = getAccess()?.menus.find((m) => m.moduleCode === code)?.moduleLabel ?? LABELS[code] ?? 'Module';
        return `${label} Dashboard`;
      },
    },
    loader: protectedLoader,
  },
];
